module.exports = __webpack_public_path__ + "img/offer.39dcb90d.png";